module.exports = __webpack_public_path__ + "img/globe_blue.24925dfd.svg";